<template>
  <div class="d-flex-row justify-start">
    <div
      class="gold_detail_chip medium-m font-family-2 t-white"
      v-for="server in servers"
      :key="server"
    >
      {{ server.title }}
    </div>
    <div
      class="gold_detail_chip medium-m font-family-2 t-white"
      v-for="faction in factions"
      :key="faction"
    >
      {{ faction.title }}
    </div>
    <div
      class="gold_detail_chip medium-m font-family-2 t-white"
      v-for="realm in [...realms].splice(0, 1)"
      :key="realm"
    >
      {{ realm.title }}
    </div>
    <div
      class="gold_detail_chip medium-m font-family-2 t-white"
      v-if="realms.length > 1"
    >
      +{{ realmLength }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    servers: {
      default: [],
    },
    factions: {
      default: [],
    },
    realms: {
      default: [],
    },
  },

  computed: {
    realmLength() {
      return this.realms.length - 1;
    },
  },
};
</script>
